import { render } from "./CustomButton.vue?vue&type=template&id=075b1746&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=075b1746&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075b1746"]])

export default __exports__